import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;



const getWorkOrderStatistics = () => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/workorder/statistics/', {
    headers: authHeader(),
  });
};

const getOpenWorkOrderStatistics = () => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/workorder/statistics-open-workorder/', {
    headers: authHeader(),
  });
};
const getWorkOrderList = (
  customer_id,
  profile_id,
  page,
  pagesize,
  search,
  groupId,
  ordering,
) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/workorder/', {
    headers: authHeader(),
    params: {
      customer_id: customer_id,
      profile_id: profile_id,
      deleted: 0,
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};

const getWorkOrderListByFilter = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/open-workorder', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};
const getWorkOrderListByFilterNoPagination = fields => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/workorder/get/', {
    headers: authHeader(),
    params: {
      deleted: 0,
      paginate: false,
      // page: page,
      // pagesize: pagesize,
      fields: fields,
    },
  });
};

const getWorkOrderReport = (customer_id, die_id) => {
  const params = {};

  if (customer_id) {
    params.customer_id = customer_id;
  }

  if (die_id) {
    params.die_id = die_id;
  }

  return axios.get(
    `${API_URL}/api/${API_VERSION}/workorder/report-by-workorder-filter/`,
    {
      headers: authHeader(),
      params: params
    },
  );
};

const getDieWiseWorkOrderReport = customer_id => {
  return axios.get(
    `${API_URL}/api/${API_VERSION}/workorder/die-wise-workorder-report/?customer_id=${customer_id}`,
    {
      headers: authHeader(),
    },
  );
};

const getWorkOrderDropdown = (page, pagesize, search, groupId, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/workorder/', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};

const workOrderForExcessStock = (page, pagesize, search, groupId, ordering) => {
  return axios.get(
    API_URL + '/api/' + API_VERSION + '/workorder/workorder-for-excess-stock/',
    {
      headers: authHeader(),
      params: {
        deleted: 0,
        page: page,
        pagesize: pagesize,
        search: search,
        ordering: ordering,
      },
    },
  );
};
const getWorkOrderStatusList = (page, pagesize, search, groupId, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/workorder/', {
    headers: authHeader(),
    params: {
      deleted: 0,
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};

const getArchiveWorkOrderList = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/workorder/?deleted=1', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};

const getWorkOrderById = id => {
  return axios.get(`${API_URL}/api/${API_VERSION}/workorder/${id}`, {
    headers: authHeader()
  });
};
const getViewWorkOrderById = (id, page, pagesize, search, ordering, print) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/workorder/`, {
    headers: authHeader(),
    params: {
      id: id,
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
      print: print,
    },
  });
};
const getViewWorkOrderByCloseOrderId = (id, formData) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/workorder/${id}/close-workorder/`,
    formData,
    {
      headers: authHeader(),
    },
  );
};
const getItemByWorkOrderId = (id, page, pagesize, search, ordering) => {
  return axios.get(
    `${API_URL}/api/${API_VERSION}/workorder/${id}/get-workorder-details/`,
    {
      headers: authHeader(),
      params: {
        page: page,
        pagesize: pagesize,
        search: search,
        ordering: ordering,
      },
    },
  );
};

const getExcessStockCountInWorkorder = (
  profileId,
  length,
  alloyId,
  temperId,
) => {
  return axios.get(
    API_URL + '/api/' + API_VERSION + '/workorder/get-excess-stock-summary/',
    {
      headers: authHeader(),
      params: {
        profile_id: profileId,
        length: length,
        alloy_id: alloyId,
        temper_id: temperId,
      },
    },
  );
};
const getWorkorderByProfileId = (id, page, pagesize, search, ordering) => {
  return axios.get(
    `${API_URL}/api/${API_VERSION}/workorder/${id}/workorder-by-die-profile/`,
    {
      headers: authHeader(),
      params: {
        page: page,
        pagesize: pagesize,
        search: search,
        ordering: ordering,
      },
    },
  );
};
const addWorkOrder = formData => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/workorder/`,
    formData, // Payload for the request body
    { headers: authHeader() },
  );
};

const addPriority = formData => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/workorder/add-to-priority/`,
    formData, // Payload for the request body
    { headers: authHeader() },
  );
};

const EditWorkOrder = (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/workorder/${id}/`, // Include the die group's ID in the URL
    formPayload, // Payload for the request body
    { headers: authHeader() },
  );
};
const archiveWorkOrder = id => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/workorder/${id}/archive/`, // Include the die group's ID in the URL
    {},
    { headers: authHeader() }, // Authentication header
  );
};
const unArchiveWorkOrder = id => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/workorder/${id}/unarchive/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    { headers: authHeader() }, // Authentication header
  );
};

const workOrderService = {
  getWorkOrderStatistics,
  getOpenWorkOrderStatistics,
  getWorkOrderList,
  getArchiveWorkOrderList,
  getWorkOrderStatusList,
  getWorkOrderById,
  getViewWorkOrderById,
  addPriority,
  getViewWorkOrderByCloseOrderId,
  getItemByWorkOrderId,
  getDieWiseWorkOrderReport,
  getWorkorderByProfileId,
  getExcessStockCountInWorkorder,
  addWorkOrder,
  getWorkOrderListByFilterNoPagination,
  EditWorkOrder,
  archiveWorkOrder,
  unArchiveWorkOrder,
  getWorkOrderDropdown,
  workOrderForExcessStock,
  getWorkOrderReport,
  getWorkOrderListByFilter,
};

export default workOrderService;
